export function openChatWidget() {
  if (window.ChatWidget?.open) {
    window.ChatWidget.open();
    return true;
  }

  const bubble = document.querySelector(".woot-widget-bubble");
  if (bubble) {
    bubble.click();
    return true;
  }

  console.warn("Chat widget is not ready yet.");
  return false;
}

// Открывает виджет ТП и отправляет сообщение от лица клиента.
// handleSendMessage / isReady — внутренности вендора (не публичный контракт):
// открываем чат сразу, сообщение шлём в фоне, опрашивая готовность сокета
// каждые 250мс до 15с. Не дождались — тихо выходим, клиент допишет сам.
export function sendSupportMessage(text) {
  const widget = window.ChatWidget;
  if (!widget) return;

  openChatWidget();

  const start = Date.now();
  const timer = setInterval(() => {
    const instance = window.ChatWidget?.instance;
    if (instance?.isReady && typeof instance.handleSendMessage === "function") {
      try {
        instance.handleSendMessage(text);
      } catch {
        // вендор переименовал внутренности — чат остаётся открытым пустым
      }
      clearInterval(timer);
    } else if (Date.now() - start > 15000) {
      clearInterval(timer);
    }
  }, 250);
}
